var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 25C20.0751 25 25 20.0751 25 14C25 7.92487 20.0751 3 14 3C7.92487 3 3 7.92487 3 14C3 20.0751 7.92487 25 14 25Z",
    fill: "#504D56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.712 10.5573C20.6319 10.2551 20.4758 9.97968 20.2594 9.75832C20.0429 9.53697 19.7735 9.3774 19.478 9.2955C18.382 9 14 9 14 9C14 9 9.618 9 8.522 9.2955C7.922 9.46012 7.45 9.94376 7.288 10.5573C7 11.6769 7 14 7 14C7 14 7 16.3344 7.288 17.4427C7.45 18.0562 7.923 18.5399 8.522 18.7045C9.618 19 14 19 14 19C14 19 18.382 19 19.478 18.7045C19.7735 18.6226 20.0429 18.463 20.2594 18.2417C20.4758 18.0203 20.6319 17.7449 20.712 17.4427C21 16.3231 21 14 21 14C21 14 21 11.6769 20.712 10.5573Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 16L16 14.0057L13 12V16Z",
    fill: "#504D56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYt);
export default __webpack_public_path__ + "static/media/yt.d99aaedccc5f6c77601b42b6d5193cc1.svg";
export { ForwardRef as ReactComponent };